module.exports = __webpack_public_path__ + "static/img/demo_2_or.665565fd.png";